<script>
export default {
  name: 'Header',
  computed: {
    headerStyle() {
      return this.$isRemoteClient ? { 'margin-top': '7rem' } : {}
    }
  }
}
</script>

<template lang="pug">
.header(:class="{ 'has-branding': this.$route.meta.hasBranding }" :style="headerStyle")
  template(v-if="this.$route.meta.headerComponent")
    component(v-bind:is="this.$route.meta.headerComponent.left")
    component(v-bind:is="this.$route.meta.headerComponent.right")
</template>

<style scoped lang="scss">
.header {
  width: 100vw;
  height: 7rem;
  min-height: 7rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;

  @media (min-width: 992px) {
    height: 12vh;
  }
}
</style>
